<template>
  <div class="page-wrapper">
    <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount != 0"
         style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
    <alert-window ref="alertWindow"></alert-window>
    <cashbox-add-operation
      :isVisible="isAddOperationWindowVisible"
      :workers="workers"
      @close-window="changeAddOperationWindowVisibility"
      @operation-added="onOperationEdited"
      v-if="editOperationAllowed"/>
    <cashbox-edit-operation
        :isVisible="isEditOperationWindowVisible"
        :operation="operationToEdit"
        @close-window="changeEditOperationWindowVisibility"
        @operation-edited="onOperationEdited"
        v-if="editOperationAllowed"/>
    <cashbox-delete-operation
      :isVisible="isDeleteOperationWindowVisible"
      :operation="operationToEdit"
      @close-window="changeDeleteOperationWindowVisibility"
      @operation-deleted="onOperationEdited"
      v-if="editOperationAllowed"/>
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="page-container">
        <div class="cabinet">
          <div class="cabinet-head cashbox-head visibility">
            <div class="title">Касса</div>
            <div class="cashbox-data">
              <section>
                <span class="section-title">Итого принято:</span>{{ formattedIncome }} руб.
              </section>
              <section>
                <span class="section-title">Выдано:</span>{{ formattedExpense }} руб.
              </section>
              <section v-show="!groupCheck">
                <span class="section-title">Выручка:</span><span>{{ formattedRevenue }} руб.</span>
              </section>
              <section>
                <span class="section-title">Остаток:</span><span :class="balance < 0 ? 'red' : 'green'">{{ formattedBalance }} руб.</span>
              </section>
            </div>
          </div>
          <div class="cabinet-body">
            <div class="cabinet-info page-scroll">
              <div class="cabinet-settings ungroup-settings">
                <div class="visibility">
                  <div class="search block block-icon">
                    <span class="icon"><i class="fa fa-search"></i></span>
                    <fieldset>
                      <input type="text" v-model="nameFilter" placeholder="Поиск по ФИО или телефону">
                    </fieldset>
                  </div>
                  <div class="date-select block" v-if="!groupCheck">
                    <fieldset>
                      <div class="block-icon">
                        <span class="icon"><i class="fa fa-calendar-o"></i></span>
                        <date-picker
                                v-model="beginTime"
                                ref="datePickerFrom"
                                format="DD.MM.YYYY"
                                lang="ru"
                                v-mask="'##.##.####'"
                                placeholder="__.__.____"
                                :clearable="false"
                                :first-day-of-week="1"
                                @panel-change="changePanelDatePickerFrom"/>
                      </div>
                      <span class="dash">-</span>
                      <div class="block-icon">
                        <span class="icon"><i class="fa fa-calendar-o"></i></span>
                        <date-picker
                                v-model="endTime"
                                ref="datePickerTo"
                                format="DD.MM.YYYY"
                                lang="ru"
                                v-mask="'##.##.####'"
                                placeholder="__.__.____"
                                :clearable="false"
                                :first-day-of-week="1"
                                @panel-change="changePanelDatePickerTo"/>
                      </div>
                    </fieldset>
                  </div>
                  <div class="dop-link" v-if="!groupCheck">
                    <span class="additionally-filters" @click="toggleDopBlock">Дополнительно<i
                      class="fa fa-angle-down"></i></span>
                    <div class="dop-filters visibility" :class="{'dop-block-open' : dopBlockOpened}">
                      <fieldset class="dop-filters-group">
                        <legend>Способ перевода</legend>
                        <div class="blue-switch">
                          <label :class="{'checked': cashType.cash}">
                            <input id="cash-type-cash" type="checkbox" v-model="cashType.cash">Наличный
                          </label>
                        </div>
                        <div class="blue-switch">
                          <label :class="{'checked': cashType.nonCash}">
                            <input id="cash-type-non-cash" type="checkbox" v-model="cashType.nonCash">Безналичный
                          </label>
                        </div>
                      </fieldset>
                      <fieldset class="dop-filters-group right">
                        <legend>Способ добавления</legend>
                        <div class="blue-switch">
                          <label :class="{'checked': creationType.automatic}">
                            <input id="creation-type-automatic" type="checkbox" v-model="creationType.automatic">Автоматический
                          </label>
                        </div>
                        <div class="blue-switch">
                          <label :class="{'checked': creationType.manually}">
                            <input id="creation-type-manually" type="checkbox" v-model="creationType.manually">Ручной
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="add-button" v-if="editOperationAllowed">
                    <button type="button" class="add add-cashbox" @click="changeAddOperationWindowVisibility"><i>+</i>
                      Добавить
                    </button>
                  </div>
                  <div class="group-check">
                    <label :class="{'checked' : groupCheck}">
                      <input id="group-check" type="checkbox" name="" v-model="groupCheck">Сгруппировать <span
                            class="hidden">по рабочим</span>
                    </label>
                  </div>
                  <div v-show="groupCheck" class="group-check">
                    <label :class="{'checked' : showBlockedWorkersFilter}">
                      <input id="blocked-check" type="checkbox" name="" v-model="showBlockedWorkersFilter">Заблокированные
                    </label>
                  </div>
                  <div v-show="groupCheck" class="group-check">
                    <label :class="{'checked' : showDismissWorkersFilter}">
                      <input id="dismiss-check" type="checkbox" name="" v-model="showDismissWorkersFilter">Уволенные
                    </label>
                  </div>
                </div>

              </div>
              <div class="cabinet-box">
                <div class="cabinet-table">
                  <table cellpadding="0" cellspacing="0" class="cashbox-table">
                    <template v-if="!groupCheck">
                      <thead>
                      <tr>
                        <td class="numb">№</td>
                        <td>Дата</td>
                        <td>Время</td>
                        <td>ФИО рабочего</td>
                        <td>Тип рабочего</td>
                        <td>ID заявки</td>
                        <td>Тип операции</td>
                        <td>Комментарий</td>
                        <td>Сумма, руб.</td>
                        <td class="cashbox-btns-cell">
                          <div class="cashbox-btns-th">
                            <i class="fa fa-pencil" aria-hidden="true"></i> <i class="fa fa-trash" aria-hidden="true"></i>
                          </div>
                        </td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(operation, index) in formattedOperations">
                        <td class="numb">{{ index + 1 }}</td>
                        <td>{{ operation.formattedDate }}</td>
                        <td>{{ operation.formattedTime }}</td>
                        <td class="name">{{ operation.fullName }}</td>
                        <td>
                          <template v-if="operation.worker">{{ operation.worker.type }}</template>
                        </td>
                        <td>
                          <template v-if="operation.orderId">
                            <a :href="'/orders/' + operation.orderId" target="_blank">{{ operation.orderId }}</a>
                          </template>
                        </td>
                        <td>{{ operation.type.name }}</td>
                        <td>{{ operation.comment }}</td>
                        <td>
                            <span
                              :class="{'red': operation.type.isExpense === true, 'green': operation.type.isExpense === false}">
                              {{ operation.formattedAmount }}
                            </span>
                        </td>
                        <td class="cashbox-btns-cell">
                          <div class="cashbox-btns">
                            <template v-if="showEditTools(operation)">
                              <a href="#" class="edit-btn-cashbox" title="Редактировать операцию"
                                 @click.stop.prevent="changeEditOperationWindowVisibility(true, operation)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                              <a href="#" class="del-btn-cashbox" title="Удалить операцию"
                                 v-if="operation.type.code != 'starting_debt'"
                                 @click.stop.prevent="changeDeleteOperationWindowVisibility(true, operation)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                            </template>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                    <template v-if="groupCheck">
                      <thead>
                      <tr>
                        <td clas="numb">№</td>
                        <td>ФИО рабочего</td>
                        <td>Тип рабочего</td>
                        <td>Сумма залога</td>
                        <td>Итоговый баланс на сегодня, руб.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(worker, index) in formattedWorkers">
                        <td class="numb">{{ index + 1 }}</td>
                        <td class="name">{{ worker.fullName }}</td>
                        <td>{{ worker.workerType }}</td>
                        <td>{{ worker.amountOfAccumulatedCollateral }}</td>
                        <td><span :class="parseInt(worker.formattedBalance) < 0 ? 'red' : 'green'">{{ worker.formattedBalance }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CashboxAddOperation from '@/views/CashboxAddOperation.vue'
  import CashboxEditOperation from '@/views/CashboxEditOperation.vue'
  import CashboxDeleteOperation from '@/views/CashboxDeleteOperation.vue'
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import api from '@/api'
  import AlertWindow from '@/components/AlertWindow.vue'
  import moment from 'moment'
  import DatePicker from 'vue2-datepicker'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'

  export default {
  name: 'Cashbox',
  components: {
    CashboxAddOperation,
    CashboxEditOperation,
    CashboxDeleteOperation,
    MenuDispatcher,
    HeaderDispatcher,
    DatePicker,
    AlertWindow
  },

    directives: {mask},

  data () {
    return {
      // Поиск по фамилии или телефону
      nameFilter: '',

      showDismissWorkersFilter: false,
      showBlockedWorkersFilter: false,

      beginTime: utils.getDateWithoutTime(new Date()),
      endTime: utils.getDateWithoutTime(new Date()),

      // Наличный / безналичный расчёт
      cashType: {
        cash: true,
        nonCash: true
      },
      // Ручное / автоматическое добавление
      creationType: {
        manually: true,
        automatic: true
      },
      // Сгруппировать по рабочим
      groupCheck: this.initGroupCheck(),
      // Открыт ли блок доп.фильтров
      dopBlockOpened: false,

      // Редактировать операции разрешено только админу и суперадмину
      isAddOperationWindowVisible: false,
      isEditOperationWindowVisible: false,
      isDeleteOperationWindowVisible: false,
      operationToEdit: null,

      // Операции
      operations: [],
      // Список всех рабочих
      workers: []
    }
  },

  computed: {
    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },
    formattedWorkers:  {
      get() {
        return this.workers
                .filter(worker => {
                  return !(this.showBlockedWorkersFilter && this.showDismissWorkersFilter) || (worker.dismiss && worker.inBlacklist)
                })
                .filter(worker => {
                  return !(!this.showBlockedWorkersFilter && !this.showDismissWorkersFilter) || (!worker.dismiss && !worker.inBlacklist)
                })
                .filter(worker => {
                  return !(this.showDismissWorkersFilter && !this.showBlockedWorkersFilter) || (worker.dismiss)
                })
                .filter(worker => {
                  return !(!this.showDismissWorkersFilter && this.showBlockedWorkersFilter) || (worker.inBlacklist)
                })
                .filter(worker => {
                  return this.filterNameAndPhone(worker.name, worker.surname, worker.patronymic, worker.phone)
                })
                .map(worker => {
                  return {
                    fullName: utils.getFullName(worker.name, worker.surname, worker.patronymic),
                    workerType: utils.getWorkerTypeName(worker.type),
                    formattedBalance: utils.formatCurrency(worker.balance),
                    amountOfAccumulatedCollateral: utils.formatCurrency(worker.amountOfAccumulatedCollateral == null ? 0 : worker.amountOfAccumulatedCollateral)
                  }
                })
      }
    },

    income: {
      get () {
        return this.filteredOperations
          .filter(operation => operation.type.isExpense === false)
          .map(operation => operation.amount)
          .reduce((amount1, amount2) => amount1 + amount2, 0)
      }
    },

    formattedIncome: {
      get () {
        return utils.formatCurrency(this.income)
      }
    },

    expense: {
      get () {
        return this.filteredOperations
          .filter(operation => operation.type.isExpense === true)
          .map(operation => operation.amount)
          .reduce((amount1, amount2) => amount1 + amount2, 0)
      }
    },

    formattedExpense: {
      get () {
        return utils.formatCurrency(this.expense)
      }
    },

    balance: {
      get () {
        return this.income - this.expense
      }
    },

    formattedBalance: {
      get () {
        return utils.formatCurrency(this.balance)
      }
    },

    revenue: { // Выручка
      get() {
        return this.operations
            .filter(operation => operation.type.affectsRevenue === true)
            .filter(operation => operation.type.isExpense === false)
            .map(operation => {
              return ((!operation.cash || operation.byCheck) ? 0.84 : 1.00)
                * operation.amount;
            })
            .reduce((amount1, amount2) => amount1 + amount2, 0)
          - this.operations
            .filter(operation => operation.type.affectsRevenue === true)
            .filter(operation => operation.type.isExpense === true
                // Из выручки вычитаем сумму погашения автоматического стартового долга
                || (operation.type.code == 'starting_debt' && !operation.manual))
            .map(operation => operation.amount)
            .reduce((amount1, amount2) => amount1 + amount2, 0);
      }
    },

    formattedRevenue: {
      get () {
        return utils.formatCurrency(this.revenue)
      }
    },

    filteredOperations: {
      get () {
        return this.operations.filter(operation => {
          return this.filterNameAndPhone(operation.worker ? operation.worker.name : '',
            operation.worker ? operation.worker.surname : '',
            operation.worker ? operation.worker.patronymic : '',
            operation.worker ? operation.worker.phone : '') &&
              ((this.cashType.cash && operation.cash) || (this.cashType.nonCash && !operation.cash)) &&
              ((this.creationType.manually && operation.manual) || (this.creationType.automatic && !operation.manual))
        })
      }
    },

    formattedOperations: {
      get () {
        // console.log('Безналичные поступления по заявке: ');
        // console.log(JSON.stringify(this.filteredOperations
        //   .filter(operation => operation.orderId && operation.type.isExpense === false && !operation.cash), null, '\t'));

        return this.filteredOperations
          // Не отображать в списке операций безналичные поступления по заявкам
          .filter(operation => {
            if (this.$route.query.showCashlessPayments)
              return true;
            return !operation.orderId || operation.cash
                || operation.type.isExpense == true
                || operation.type.code == 'starting_debt';
          })
          .map(operation => {
            let fOperation = Object.assign({}, operation);
            fOperation = Object.assign(fOperation, {
              formattedDate: this.formatDate(fOperation.date),
              formattedTime: utils.formatTime(new Date(fOperation.date)),
              fullName: fOperation.worker ? utils.getFullName(fOperation.worker.name,
                fOperation.worker.surname, fOperation.worker.patronymic) : '',
              formattedAmount: (fOperation.type.isExpense === true ? '-' : '') +
                  utils.formatCurrency(fOperation.amount)
            });
            return fOperation;
          });
      }
    },

    editOperationAllowed: {
      get () {
        let isAllowed
        switch (this.$store.getters.roleCode) {
          case 'ROLE_SUPER_ADMIN':
          case 'ROLE_ADMIN':
            isAllowed = true
            break
          default:
            isAllowed = false
        }
        return isAllowed
      }
    }
  },

  methods: {

    showEditTools(operation) {
      return !!operation.manual && !(utils.getDateWithoutTime(new Date(operation.date)).getTime() !== utils.getDateWithoutTime(new Date()).getTime() && utils.checkRole(this.$store.getters.roleCode, ['ROLE_ADMIN']));
    },

    toggleDopBlock () {
      this.dopBlockOpened = !this.dopBlockOpened
    },

    changeAddOperationWindowVisibility (value) {
      this.isAddOperationWindowVisible = !!value;
      utils.changeShadowVisibility(!!value);
    },

    changeEditOperationWindowVisibility (value, operation) {
      this.operationToEdit = operation;
      this.isEditOperationWindowVisible = !!value;
      utils.changeShadowVisibility(!!value);
    },

    changeDeleteOperationWindowVisibility (value, operation) {
      this.operationToEdit = operation;
      this.isDeleteOperationWindowVisible = !!value;
      utils.changeShadowVisibility(!!value);
    },

    formatDate (givenDate) {
      return moment(String(new Date(givenDate))).format('DD.MM.YYYY')
    },

    filterNameAndPhone (name, surname, patronymic, phone) {
      // Фильтрация по ФИО / телефону
      if (!this.nameFilter) {
        return true
      }

      let nameFilter = this.nameFilter.trim().toLowerCase()

      return ((`${surname} ${name} ${patronymic}`).trim().toLowerCase().includes(nameFilter)) ||
          (phone && phone.trim().toLowerCase().indexOf(nameFilter) !== -1)
    },

    initGroupCheck () {
      let groupCheck
      let shustrikoffCashboxTab = sessionStorage.getItem('shustrikoffCashboxTab')
      if (shustrikoffCashboxTab != null) {
        groupCheck = shustrikoffCashboxTab == 'true'
      } else {
        groupCheck = true
      }
      return groupCheck
    },

    initOperationTypes () {
      return api
        .getCashboxOperationTypes()
        .then(operationTypes => {
          if (operationTypes) {
            this.$store.commit('updateCashboxOperationTypes', operationTypes)
          }
        })
    },

    initWorkers () {
      return api
        .getAll()
        .then(workers => {
          if (workers) {
            this.workers = workers
          }
        })
    },

    initCashboxOperations () {
      if (!this.beginTime) {
        this.$refs.alertWindow.show('Ошибка обновления данных', 'Необходимо заполнить дату "от" в периоде');
        return;
      }

      if (!this.endTime) {
        this.$refs.alertWindow.show('Ошибка обновления данных', 'Необходимо заполнить дату "до" в периоде');
        return;
      }

      return api
        .getCashboxOperations(this.beginTime.valueOf(), this.endTime.valueOf())
        .then(cashboxOperations => {
          if (cashboxOperations) {
            this.operations = cashboxOperations
          }
        })
    },

    onOperationEdited () {
      this.initCashboxOperations();
      this.initWorkers()
    },

    addDatePickerWatchers() {
      this.$watch(
        () => {
            if(this.$refs.datePickerFrom != undefined)
          return this.$refs.datePickerFrom.userInput
        },
        (newVal, oldVal) => {
          if (utils.checkIfValidDate(newVal)) {
            let newDate = utils.spotNewValueForDatePicker(newVal, oldVal);
            this.beginTime = newDate;
          }
        }
      );

      this.$watch(
        () => {
            if(this.$refs.datePickerTo != undefined)
          return this.$refs.datePickerTo.userInput
        },
        (newVal, oldVal) => {
          if (utils.checkIfValidDate(newVal)) {
            let newDate = utils.spotNewValueForDatePicker(newVal, oldVal);
            this.endTime = newDate;
          }
        }
      );
    },

    changePanelDatePickerFrom(panel) {
      if (panel !== 'NONE')
        this.$refs.datePickerTo.popupVisible = false;
    },

    changePanelDatePickerTo(panel) {
      if (panel !== 'NONE')
        this.$refs.datePickerFrom.popupVisible = false;
    }
  },

  watch: {
    groupCheck (val) {
      sessionStorage.setItem('shustrikoffCashboxTab', val)
    },

    beginTime (newBeginTime) {
      if (!newBeginTime)
        return;

      if (newBeginTime > this.endTime) {
        this.endTime = newBeginTime;
      } else {
        this.initCashboxOperations();
      }
    },

    endTime (newEndTime) {
      if (!newEndTime)
        return;

      if (newEndTime < this.beginTime) {
        this.beginTime = newEndTime;
      } else {
        this.initCashboxOperations();
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('cabinet-page');

    this.initOperationTypes();
    this.initWorkers();
    this.addDatePickerWatchers();
    this.initCashboxOperations()
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove('cabinet-page')
  }
}
</script>

